export default "__VITE_ASSET__d2132f17__"